import { requiredIf } from "vuelidate/lib/validators";
import { updateForm } from "@state/modules";

export const state = {
  form: {
    Diagnosis: null,
    Over60: null,
    ReferralOption: [],
    ReferralReason: null,
    AwareOfReferral: null
  }
};

export const validations = {
  form: {
    Diagnosis: {
      requiredIf: requiredIf(vueInstance => {
        return vueInstance.isProfessional === "yes";
      })
    },
    ReferralOption: {
      requiredIf: requiredIf(vueInstance => {
        return vueInstance.isProfessional === "yes";
      })
    },
    ReferralReason: {
      requiredIf: requiredIf(vueInstance => {
        return vueInstance.ReferralOption.includes("Other");
      })
    }
  }
};

export const getters = {};

export const mutations = {
  updateForm
};

export const actions = {};
